import { HttpClient, HttpParams } from '@angular/common/http';;
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { API_URL } from '../../configurations/server-config';

@Injectable({
  providedIn: 'root'
})
export class DestinationService {

  getdestinationville(value: any): any{
    return this.http.get(`${API_URL}/villedestination/${value}`);
  }

  constructor(private http: HttpClient) { }

  getdestinations(): Observable<any> {
    return this.http.get(`${API_URL}/destination`);
  }

  getville(): Observable<any> {
    return this.http.get(`${API_URL}/ville`);
  }

  getdestinationlist(page: any, size: any): Observable<any> {
    return this.http.get(`${API_URL}/destinationlist?page=${page}&size=${size}`);
  }

  // destination services
  saveDestination(value: any): any{
    return this.http.post(`${API_URL}/destination`, value);
  }
  updateDestination(value: any): any{
    return this.http.put(`${API_URL}/destination`, value);
  }

  deletedestination(id: any): any {
    return this.http.delete(`${API_URL}/destination/${id}`);
  }

  getAlldestination(page= 0, size= 10): any {
    return this.http.get(`${API_URL}/destinationlist?page=${page}&size=${size}`);
  }

  getdestinationbycode(code: any): Observable<any> {
    return this.http.get(`${API_URL}/findbydestcode?code=${code}`);
  }

  getCriteriaSearch(criteria: any, page = 0, size = 10, sort = 'creationdate', direction = 'desc'): any {
    let params = new HttpParams()
      .set('page', page.toString())
      .set('size', size.toString())
      .set('sort', sort)
      .set('direction', direction);
      
    Object.keys(criteria).forEach(key => {
      if (criteria[key] !== null && criteria[key] !== undefined && criteria[key] !== '') {
        params = params.set(key, criteria[key]);
      }
    });

    return this.http.get(`${API_URL}/destination/criteria`, { params });
  }

}